import clsx from 'clsx';
import styles from './styles.module.scss';

type Props = {
    title?: string;
    tabIndex?: number;
    ariaLabel?: string;
};

export const ParkingFloorHeader = ({ title, tabIndex, ariaLabel }: Props) => {
    return (
        <section className={styles['parking-map-header']} data-region-nav data-region-order={1}>
            <div className={styles['parking-map-header__title-group']}>
                {title && (
                    <p
                        tabIndex={tabIndex}
                        data-interactive
                        data-region-order={1}
                        aria-label={ariaLabel}
                        className={clsx(styles['parking-map-header__floor'], 'focus-border')}
                    >
                        {title}
                    </p>
                )}
            </div>
        </section>
    );
};
